var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#347FFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0813 7.34344L9.46744 11.7028L9.45731 11.7292L9.16144 11.1358L8.54269 11.4171L10.1655 7.03125L10.7843 6.75L11.0807 7.34344H11.0813ZM15.12 7.44637L13.5067 11.8125L13.2103 11.2174L12.5916 11.4986L12.6292 11.3963L14.2419 7.03125L14.8607 6.75L15.156 7.34344L15.12 7.44637ZM11.6663 11.2219L12.6163 8.65519L11.9959 8.93644L11.7011 8.34187L10.7483 10.908L11.0436 11.5031L11.6663 11.2219ZM6.52669 8.69062H3.68888L4.17263 9.14062L3.68888 9.59794H6.52387L7.00538 9.14062L6.52669 8.69062ZM3.29625 10.5936H7.88344L7.40137 11.0475L7.88344 11.5003H3.29625L2.8125 11.0475L3.29625 10.5936ZM4.70306 6.78656H9.28744L8.80706 7.24106L9.288 7.69388H4.70363L4.21987 7.2405L4.70363 6.78656H4.70306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExmo);
export default __webpack_public_path__ + "static/media/exmo.0501a0103c729ddca704ab9f7e4d115a.svg";
export { ForwardRef as ReactComponent };